
import Vue from 'vue';

interface Props {
  value: any;
  error: boolean;
}

interface Methods {
  handleInput: (value: any) => void;
}

export default Vue.extend<unknown, Methods, unknown, Props>({
  props: {
    value: {
      type: undefined,
      default: null,
      required: true,
    },
    error: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  methods: {
    handleInput(val) {
      this.$emit('input', val);
    },
  },
});
